<template>
  <div class="head">
    <div class="headBox">
      <div class="headLeft">
        2026年北京市社会组织服务项目征集填报系统
      </div>
      <div class="headRight">
        <p>欢迎：{{user.nickname}}</p>
        <span class="guanb" @click="sginout">退出</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headP",
  data() {
    return {

    }
  },
  props: {

  },
  computed: {
    token() {
      return this.$store.state.admintoken
    },
    user() {
      return this.$store.state.adminuser
    },
  },
  components: {},
  created() {

  },
  methods: {
    sginout() {
      this.$confirm(
        '您确定要退出吗？',
        '温馨提示', {
          confirmButtonText: '确定',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }
      ).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.replace('/adminlogin')
        })
      })
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.head {
  .headBox {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;
    background: #3381c3;

    .headLeft {
      font-size: 24px;
      letter-spacing: 1px;
      color: #ffffff;
      font-weight: bold;
    }

    .headRight {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      p {
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
      }

      .guanb {
        display: block;
        width: max-content;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
        font-size: 16px;
        color: #fff;
        margin-left: 30px;
        cursor: pointer;
      }

    }
  }
}
</style>


